import { BRAND_NAMES } from "@/app/utils/utils";
import { FC } from "react";
import { FaCheck } from "react-icons/fa";

interface ServiceItem {
  icon: string;
  text: string;
}

const serviceItems: ServiceItem[] = [
  { icon: "🛠️", text: "Agendar Serviços" },
  { icon: "⚠️", text: "Agendar Recall" },
  { icon: "📜", text: "Revalidar a Garantia do seu Veículo" },
  { icon: "🔍", text: "Consultar Agendamentos Existentes" },
  { icon: "📅", text: "Reagendar Serviços" },
  { icon: "❌", text: "Cancelar Agendamentos" },
];

const SchedulingSection: FC = () => {
  return (
    <section className="py-8 m-auto px-4 md:py-12 md:px-6 text-black">
      <div className="max-w-5xl mx-auto">
        {/* Título centralizado */}
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-3xl  mb-4">
            Agendamento de Serviços {BRAND_NAMES.DEFAULT}:
          </h2>
          <p className="text-lg md:text-xl font-medium ">
            Simples, Rápido e Disponível 24h por Dia!
          </p>
        </div>

        {/* Grid de duas colunas */}
        <div className="grid md:grid-cols-2 gap-8 items-center max-w-4xl mx-auto">
          {/* Coluna de texto */}
          <div className="space-y-6">
            <p className="text-base md:text-sm text-gray-700">
              Na {BRAND_NAMES.DEFAULT}, sabemos como é importante oferecer
              praticidade e conveniência aos nossos clientes. Por isso, criamos
              um sistema de agendamento de serviços online disponível todos os
              dias da semana, 24 horas por dia, com o suporte de um assistente
              virtual.
            </p>
            <p className="text-base md:text-sm text-gray-700">
              Nosso assistente virtual está preparado para ajudá-lo a agendar
              serviços de forma simples e eficiente. Com apenas alguns cliques,
              você pode:
            </p>
          </div>

          {/* Coluna de serviços */}
          <div className="border border-gray-600 p-4">
            <div className="space-y-3">
              {serviceItems.map((item, index) => (
                <div key={index} className="flex items-center ">
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-gray-600 text-sm" />
                    <span className="text-gray-600 text-sm">{item.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchedulingSection;
